import type { SiteConfig } from "../types";

export const siteConfig: SiteConfig = {
  name: "Shifa Medical Centre",
  tagline: "Healing with Purpose. Changing Lives for Good",
  description:
    "Shifa Medical Centre is a leading multi-specialty hospital in Srinagar, J&K, offering world-class healthcare services across 20 departments with a team of over 50 experienced specialists dedicated to patient-centered care.",
  contact: {
    phone: "0194-247-3648",
    emergency: "0194-247-3383",
    email: "shifamedcenter@gmail.com",
    whatsapp: "9090909090",
  },
  phoneGroups: [
    {
      label: "OPD",
      numbers: [
        { display: "94694 73383", tel: "+919469473383" },
        { display: "94190 53846", tel: "+919419053846" },
        { display: "91499 78937", tel: "+919149978937" },
      ],
    },
    {
      label: "Gastro OPD",
      numbers: [{ display: "96227 38206", tel: "+919622738206" }],
    },
    {
      label: "Landline",
      numbers: [
        { display: "0194 247 3648", tel: "+911942473648" },
        { display: "0194 406 4315", tel: "+911944064315" },
        { display: "0194 247 3383", tel: "+911942473383" },
        { display: "98584 73383", tel: "+919858473383" },
      ],
    },
  ],
  address: {
    street: "Magarmal-Bagh Circle",
    city: "Srinagar",
    state: "J&K",
    pincode: "190008",
    full: "Magarmal-Bagh Circle, Srinagar, J&K 190008",
  },
  hours: [
    { day: "Monday", time: "8:00 AM - 5:00 PM" },
    { day: "Tuesday", time: "8:00 AM - 5:00 PM" },
    { day: "Wednesday", time: "9:00 AM - 6:00 PM" },
    { day: "Thursday", time: "9:00 AM - 6:00 PM" },
    { day: "Friday", time: "10:00 AM - 5:00 PM" },
    { day: "Saturday", time: "10:00 AM - 5:00 PM" },
    { day: "Sunday", time: "Emergency Only" },
  ],
  leadership: {
    director: "Dr. Gulzar Ahmad",
    coChairman: "Dr. Bilal Khan",
  },
  social: {
    facebook: "https://facebook.com/shifamedicalcentre",
    instagram: "https://instagram.com/shifamedicalcentre",
    twitter: "https://twitter.com/shifamedcentre",
    youtube: "https://youtube.com/@shifamedicalcentre",
  },
  stats: {
    years: 25,
    patients: 50000,
    doctors: 50,
    departments: 20,
    satisfaction: 84,
  },
};
